import { capitalize } from "lopermut"

export function formatCanonicalTopicLabel(label: string | null | undefined): string {
  const value = label ? capitalize(label) : (label ?? "")
  return value ?? ""
}
